import { useTranslation } from "react-i18next";
import { AccessDenied, Delayed } from "@pl/paylican-ui-kit";
import React from "react";

const AccessDeniedTranslated = () => {
  const { t } = useTranslation();
  return (
    <Delayed>
      <AccessDenied
        title={t("Access denied")}
        description={t(
          // eslint-disable-next-line max-len
          "You do not have permission to access this page. Please contact the help desk {{ helpDeskEmail }} if you think you should see this page.",
          {
            helpDeskEmail: process.env.REACT_APP_HELP_DESK_EMAIL
          }
        )}
      />
    </Delayed>
  );
};

export default AccessDeniedTranslated;
